import { render, staticRenderFns } from "./Stahlzaun.vue?vue&type=template&id=63336dbc&"
import script from "./Stahlzaun.vue?vue&type=script&lang=js&"
export * from "./Stahlzaun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports